module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fc-Ge-Hc-Ia.a839db5a.png";